import React from 'react';

import { Investments } from './investments/Investments';
import { InvestInfo } from './investInfo/InvestInfo';
import { Invest } from './invest/Invest';
import { ConvenientInvestments } from './convenientInvestments/ConvenientInvestments';
import { FinancialSegment } from './financialSegment/FinancialSegment';
import { CareFuture } from './careFuture/CareFuture';
import { Licenses } from './licenses/Licenses';
import { Rewards } from './rewards/Rewards';
import { FewSteps } from './fewSteps/FewSteps';

import './home.scss';

export const Home = () => {
  return (
    <div className="home">
      <Investments />
      <InvestInfo />
      <Invest />
      <ConvenientInvestments />
      <FinancialSegment />
      <CareFuture />
      <Licenses />
      <Rewards />
      <FewSteps />
    </div>
  );
};
